import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createSelector } from '@reduxjs/toolkit';
import { getAvailableStatusText, getCurrentCity, getCurrentCityId, getHSAvailableStatusText, getNotAvailableStatusText, getNotAvailableStatusTextMobile } from "../blocks/checkAddress/selectors";
import { getCheckAddressModuleData } from "../selectors";
export var getCheckAddressFormData = getCheckAddressModuleData;
export var getCheckAddressCityId = getCurrentCityId;
export var getCheckAddressStreetId = function getCheckAddressStreetId(state) {
  return getCheckAddressFormData(state).streetId;
};
export var getCheckAddressStreetFiasId = function getCheckAddressStreetFiasId(state) {
  return getCheckAddressFormData(state).streetFiasId;
};
export var getCheckAddressHouseId = function getCheckAddressHouseId(state) {
  return getCheckAddressFormData(state).houseId;
};
export var getCheckAddressHouse = function getCheckAddressHouse(state) {
  return getCheckAddressFormData(state).house;
};
export var getCheckAddressFlat = function getCheckAddressFlat(state) {
  return getCheckAddressFormData(state).flat;
};
export var getPositionNavButtons = function getPositionNavButtons(state) {
  return getCheckAddressFormData(state).positionNavButtons;
};
export var getRenderTooltip = function getRenderTooltip(state) {
  return getCheckAddressFormData(state).renderTooltip;
};
export var getCheckAddressConnected = function getCheckAddressConnected(state) {
  return getCheckAddressFormData(state).connected;
};
export var getCheckAddressHSConnected = function getCheckAddressHSConnected(state) {
  return getCheckAddressFormData(state).highSpeed;
};
export var getLoadingStatusForButton = function getLoadingStatusForButton(state) {
  return getCheckAddressFormData(state).isLoading;
};

/** Yandex maps geocode response */
export var getCheckAddressYandexGeocoderData = function getCheckAddressYandexGeocoderData(state) {
  return getCheckAddressModuleData(state).geocodeResults;
};
export var getCheckAddressGeometry = function getCheckAddressGeometry(state) {
  var _getCheckAddressYande;
  return (_getCheckAddressYande = getCheckAddressYandexGeocoderData(state)) === null || _getCheckAddressYande === void 0 ? void 0 : _getCheckAddressYande.coordinates;
};
export var getCheckAddressBoundedBy = function getCheckAddressBoundedBy(state) {
  var _getCheckAddressYande2;
  return (_getCheckAddressYande2 = getCheckAddressYandexGeocoderData(state)) === null || _getCheckAddressYande2 === void 0 ? void 0 : _getCheckAddressYande2.boundedBy;
};

/**
 * * @returns { street, streetId, streetFiasId, city, cityId, house, houseId, houseFiasId, flat, isConnected }
 */
export var getCheckAddressRequestData = createSelector([getCheckAddressModuleData, getCurrentCity, getCurrentCityId], function (formData, city, cityId) {
  return _objectSpread(_objectSpread({}, formData), {}, {
    city: city,
    cityId: cityId
  });
});
export var getFullAddressData = createSelector([getCheckAddressRequestData], function (_ref) {
  var city = _ref.city,
    cityId = _ref.cityId,
    house = _ref.house,
    houseId = _ref.houseId,
    flat = _ref.flat,
    street = _ref.street,
    streetId = _ref.streetId;
  return {
    City: city,
    CityId: cityId,
    Street: street,
    StreetId: streetId,
    House: house,
    HouseId: houseId,
    Flat: flat
  };
});
export var getConnectionStatusText = createSelector([getCheckAddressHSConnected, getHSAvailableStatusText, getCheckAddressConnected, getAvailableStatusText, getNotAvailableStatusTextMobile], function (isHighSpeed, isHSAvailableStatusText, isSuccess, isAvailableStatusText, isntAvailableStatusTextMobile) {
  return isHighSpeed && isHSAvailableStatusText || isSuccess && isAvailableStatusText || isntAvailableStatusTextMobile;
});

// TODO: после миграции на метод проверки адреса в одно поле удалить селектор
export var getFullAddress = createSelector([getCheckAddressRequestData], function (_ref2) {
  var city = _ref2.city,
    flat = _ref2.flat,
    house = _ref2.house,
    street = _ref2.street;
  return city && street && house && flat && "".concat(city, ", ").concat(street, ", \u0434. ").concat(house, ", \u043A\u0432. ").concat(flat);
});
export var getDisableButtonForm = createSelector([getCheckAddressFlat, getCheckAddressHouse], function (flat, house) {
  return !!house && !!flat;
});
export var getTextStatusForMobileCheckAddress = createSelector([getCheckAddressConnected, getCheckAddressHSConnected, getHSAvailableStatusText, getAvailableStatusText, getNotAvailableStatusText], function (connected, highSpeed, hsAvailableStatusText, availableStatusText, notAvailableStatusText) {
  if (connected) {
    return highSpeed ? hsAvailableStatusText : availableStatusText;
  }
  return notAvailableStatusText;
});